import { render, staticRenderFns } from "./OrderAgentsChart.vue?vue&type=template&id=5f55e3b0&"
import script from "./OrderAgentsChart.vue?vue&type=script&lang=js&"
export * from "./OrderAgentsChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports